export default __webpack_public_path__ + "static/media/card-language-icon.2ba03858.svg";